import Service from "../Service"

const resource = "dispatchtunnelschamber/"

export default {

    save(cmp, requestID){
        return Service.post(resource + "save", cmp,{
            params: {requestID: requestID},
        });
    },
    pagination(dtr, requestID){
        return Service.post(resource + "pagination", dtr,{
            params:{requestID: requestID},
        });
    },
    list(fas, requestID) {
        return Service.post(resource + "List", fas, {
          params: { requestID: requestID },
        });
    },
    detail(obj, requestID) {
        return Service.post(resource + "detail", obj, {
          params: { requestID: requestID },
        });
    },
    
}